export default __webpack_public_path__ + "static/media/Mortgage_Banner.f9a8c81d.png";